
















































































import { Component, Prop, Vue } from 'vue-property-decorator'
import DateClass from '@/app/module/date'
@Component
export default class AreaList extends Vue {
  @Prop() private data!: any

  private dateToStringYmd (date: any) {
    if (date !== '') {
      const updateDate = new Date(date.replace(/-/g, '/'))
      const formingDate = DateClass.toDoubleDigits(updateDate.getFullYear()) + '年' + DateClass.toDoubleDigits(updateDate.getMonth() + 1) + '月' + DateClass.toDoubleDigits(updateDate.getDate()) + '日'
      return formingDate
    }
  }
}
